const defaultPath = "demo";

export const demoRouters = [
  {
    name: `DemoHome`,
    path: `/${defaultPath}`,
    component: () => import(`../../views/${defaultPath}/Home.vue`),
  },
  {
    name: `DemoDetail`,
    path: `/${defaultPath}/:demo`,
    component: () => import(`../../views/${defaultPath}/Detail.vue`),
  }
];
